var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"info-card",attrs:{"flat":""}},[_c('v-card-subtitle',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }